import AuthMixin from '@/components/mixins/auth-mixin'
import { usercentricsCmp } from '@base-shared/composables/use-usercentrics-cmp'

export default {
  name: 'privacy',
  components: {},
  inject: [
    '$utils'
  ],
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {}
  },
  methods: {
    changeCookiesPreference () {
      usercentricsCmp().toggleDisplay()
    }
  },
  mounted () {
    this.isAuthenticated()
  }
}
